export default __webpack_public_path__ + "static/media/tokenDemand.b34a106e.png";